__turbopack_context__.v({
  "blink": "LoadingDots-module__yaQm_a__blink",
  "root": "LoadingDots-module__yaQm_a__root",
});
